<template>
  <div :id="sid+chartName" class="chart-wrapper" :style="esize"></div>
</template>
<script>
//import { CounterAmount } from "@/libs/lib.js";
//import {chartText} from "@/libs/mixins/chartSubText.js";

export default {
  name: "industryCatagory",
  data() {
    return {
      chartName: this.$options.name,
      chartData: []
    };
  },
  props: {
    choosedOptions: {
      type: Object,
      default() {
        return {
          selectedList: [],
          keyword: ""
        };
      }
    },
    sid:{
      type:String,
      default:'a',
    },
    timeRange:{
      type:Number,
      default:7

    },
    esize: {
      type: Object,
      default() {
        return { height: "20rem", width: "100%" };
      }
    },
    drawAgain: {
      type: Number,
      default: 1
    }
  },
  //mixins: [chartText],
  mounted() {},
  watch: {
    drawAgain: {
      immediate: true,
      handler(newVal) {
        if (newVal > 0) {
          this.get_data();
        }
      }
    }
  },
  computed: {
    title(){
      if(this.timeRange===1){
        return "今日不同行业客户订单金额";
      }else{
        return "近"+this.timeRange+"日不同行业客户订单金额";
      }
    }
  },
  methods: {
    get_data() {
      let userToken = localStorage.getItem("current_user_token");
      this.$axios
        .post(this.$url + "/statistics", {
          askData: this.chartName,
          choosedOptions: this.choosedOptions,
          timeRange:this.timeRange,
          userToken: userToken
        })
        .then(response => {
          response.data.sort((a,b)=>{return parseInt(b.value)-parseInt(a.value);});
          this.chartData = response.data; 
          this.drawIt();
          });
    },
    drawIt() {
      let vm = this;
      let myChart = this.$echarts.init(document.getElementById(vm.sid+vm.chartName));
      // 绘制图表
      myChart.setOption({
        backgroundColor: "#fff",
        title: {
          text: vm.title,
          subtext: '',//vm.selectedListTextFormat(vm.choosedOptions.selectedList),
          left: "center",
          top: "6%",
          textStyle: {
            fontSize:'0.6rem',
            fontWeight:800,
            color: "#888"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: function(a){
            return a.data.name+':'+a.percent+'%</br>'+'￥'+a.data.value/10000+'万元';
          }
            //"{b} :{c}{d}%"
        },
        legend: {
          width:'85%',
          bottom: 30
        },
        dataset: {
          source: vm.chartData
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: ["20%", "30%"],
            center: ["55%", "39%"],
            
            itemStyle: {
              opacity: 0.9
            }
          }
        ],
        grid: {
          x: "20%",
          y: "20%",
          x2: "20%",
          y2: "20%",
          borderWidth: 10
        },
        label: {
          formatter: function(a){
            return a.data.name+':'+a.percent+'%';
          },
          fontSize:'10',
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 5,
            length2: 10
          }
        }
      });
      /**myChart.on('click', function (value) {
                    vm.$emit("clickToChange", { 'value': [value.name], 'key': vm.chartKey });

                });**/
      myChart.on("legendselectchanged", function(value) {
        vm.$emit("clickToAppend", {
          value: value.selected,
          key: vm.keyProp
        });
      });
    }
  }
};
</script>
<style scoped>
.chart-wrapper {
  border: 1px solid #f9f9f9;
  border-radius: 3px;
  margin: 0 auto;
}
</style>